/**
 * REPACK STORE
 */

import api from "Api";

const state = {
    page: {},
    pending_parts_summary: null,
    pending_batches: null,
    repack: null,
    packages: JSON.parse(localStorage.getItem("packages")) || null,
    repacks_filter: {
        search: "",
        company_id: "",
        page_size: 0,
        page_num: 1,
    },
};

// getters
const getters = {};

// actions
const actions = {
    async fetchRepack({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitRepack", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitRepack", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateRepack", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitRepack(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateRepack(state, payload) {
        if (payload.method == "post" && payload.with) {
            // allows to push multiple 'with' into property
            let property = _.get(state, payload.property);
            if (property == null) _.set(state, payload.property, []);
            state[payload.property].push.apply(state[payload.property], Array.isArray(payload.with) ? [...payload.with] : [payload.with]);
        } else if (payload.method == "patch" && payload.property && payload.with) {
            let curr_item = _.get(state, payload.property);
            if (Array.isArray(curr_item)) {
                let curr_id = payload.id ? payload.id : payload.with[payload.pk];
                curr_item = curr_item[curr_item.findIndex((obj) => obj[payload.pk] == curr_id)];
            }
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            state[payload.property].splice(
                state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
    resetRepack(state) {
        state.page = {};
        state.pending_parts_summary = null;
        state.pending_batches = null;
        state.repack = null;
        state.packages = JSON.parse(localStorage.getItem("packages")) || null;
        state.repacks_filter = {
            search: "",
            company_id: "",
            page_size: 0,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
